import { supabase } from '@/integrations/supabase/client';

export async function loadActiveCurrencies() {
  const { data } = await supabase
    .from('currencies')
    .select('code, name, symbol')
    .eq('is_active', true)
    .order('code');
  return Array.isArray(data) ? data : [];
}

export async function getUserDefaultCurrency(): Promise<string> {
  const { data: sess } = await supabase.auth.getSession();
  const uid = sess?.session?.user?.id;
  if (uid) {
    const { data: prof } = await supabase
      .from('user_profiles')
      .select('default_currency')
      .eq('id', uid)
      .single();
    const dc = (prof as any)?.default_currency;
    if (typeof dc === 'string' && dc.trim()) return String(dc).toUpperCase();
  }
  return 'CAD';
}

export async function loadUserPortfolios(): Promise<Array<{ id: string; name: string; portfolio_type?: string }>> {
  const { data: sess, error: sessErr } = await supabase.auth.getSession();
  if (sessErr) throw sessErr;
  const uid = sess?.session?.user?.id;
  let query = supabase
    .from('portfolios' as any)
    .select('id, name, portfolio_type')
    .order('created_at', { ascending: false }) as any;
  if (uid) query = query.eq('user_id', uid);
  const { data, error } = await query;
  if (error) throw error;
  const normalized: Array<{ id: string; name: string; portfolio_type?: string }> = Array.isArray(data)
    ? (data as any[]).map((p) => ({ id: String((p as any).id), name: String((p as any).name), portfolio_type: (p as any)?.portfolio_type ?? undefined }))
    : [];
  return normalized;
}

export async function createUserPortfolio(name: string, type: string): Promise<{ id: string; name: string; portfolio_type?: string }> {
  const { data: { session }, error: sessionError } = await supabase.auth.getSession();
  if (sessionError) throw sessionError;
  if (!session?.user?.id) throw new Error('No user logged in');
  const { data, error } = await supabase
    .from('portfolios' as any)
    .insert({ name: name?.trim() || 'New Portfolio', status: 'in_progress', user_id: session.user.id, portfolio_type: (type || 'personal') })
    .select('id, name, portfolio_type')
    .single();
  if (error) throw error;
  return { id: (data as any).id as string, name: (data as any).name as string, portfolio_type: (data as any).portfolio_type as string | undefined };
}
